var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  ref: "userFrom",
                  attrs: {
                    inline: "",
                    size: "small",
                    model: _vm.userFrom,
                    "label-position": _vm.labelPosition,
                    "label-width": "75px",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row search-form row-between" },
                    [
                      _c(
                        "div",
                        { staticClass: "search-form-box" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "用户搜索：" } },
                            [
                              _c("el-input", {
                                staticClass: "selWidth",
                                attrs: {
                                  placeholder: "请输入姓名或手机号",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.userFrom.keywords,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userFrom, "keywords", $$v)
                                  },
                                  expression: "userFrom.keywords",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.collapse
                        ? _c(
                            "el-form-item",
                            { staticClass: "search-form-sub" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "ios-search",
                                    label: "default",
                                  },
                                  on: { click: _vm.userSearchs },
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "ResetSearch mr14",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.reset("userFrom")
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "ivu-ml-8",
                                  on: {
                                    click: function ($event) {
                                      _vm.collapse = !_vm.collapse
                                    },
                                  },
                                },
                                [
                                  !_vm.collapse
                                    ? [
                                        _vm._v(" 展开 "),
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down",
                                        }),
                                      ]
                                    : [
                                        _vm._v(" 收起 "),
                                        _c("i", {
                                          staticClass: "el-icon-arrow-up",
                                        }),
                                      ],
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.collapse
                    ? _c(
                        "div",
                        { staticClass: "acea-row search-form" },
                        [
                          _c(
                            "div",
                            { staticClass: "search-form-box" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "用户分组：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                        filterable: "",
                                        multiple: "",
                                      },
                                      model: {
                                        value: _vm.groupData,
                                        callback: function ($$v) {
                                          _vm.groupData = $$v
                                        },
                                        expression: "groupData",
                                      },
                                    },
                                    _vm._l(
                                      _vm.groupList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            value: item.id,
                                            label: item.groupName,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "用户标签：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                        filterable: "",
                                        multiple: "",
                                      },
                                      model: {
                                        value: _vm.labelData,
                                        callback: function ($$v) {
                                          _vm.labelData = $$v
                                        },
                                        expression: "labelData",
                                      },
                                    },
                                    _vm._l(
                                      _vm.labelLists,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            value: item.id,
                                            label: item.name,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "国家：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      on: { "on-change": _vm.changeCountry },
                                      model: {
                                        value: _vm.userFrom.country,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.userFrom, "country", $$v)
                                        },
                                        expression: "userFrom.country",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { value: "", label: "全部" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "CN", label: "中国" },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          value: "OTHER",
                                          label: "国外",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "省份：" } },
                                [
                                  _c("el-cascader", {
                                    staticClass: "selWidth",
                                    attrs: {
                                      options: _vm.addresData,
                                      props: _vm.propsCity,
                                      filterable: "",
                                      clearable: "",
                                    },
                                    on: { change: _vm.handleChange },
                                    model: {
                                      value: _vm.address,
                                      callback: function ($$v) {
                                        _vm.address = $$v
                                      },
                                      expression: "address",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "消费情况：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.userFrom.payCount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userFrom,
                                            "payCount",
                                            $$v
                                          )
                                        },
                                        expression: "userFrom.payCount",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { value: "", label: "全部" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "0", label: "0" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "1", label: "1+" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "2", label: "2+" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "3", label: "3+" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "4", label: "4+" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: "5", label: "5+" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "时间选择：" } },
                                [
                                  _c("el-date-picker", {
                                    staticClass: "selWidth",
                                    attrs: {
                                      align: "right",
                                      "unlink-panels": "",
                                      "value-format": "yyyy-MM-dd",
                                      format: "yyyy-MM-dd",
                                      size: "small",
                                      type: "daterange",
                                      placement: "bottom-end",
                                      placeholder: "自定义时间",
                                      "start-placeholder": "开始时间",
                                      "end-placeholder": "结束时间",
                                    },
                                    on: { change: _vm.onchangeTime },
                                    model: {
                                      value: _vm.timeVal,
                                      callback: function ($$v) {
                                        _vm.timeVal = $$v
                                      },
                                      expression: "timeVal",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "访问情况：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.userFrom.accessType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userFrom,
                                            "accessType",
                                            $$v
                                          )
                                        },
                                        expression: "userFrom.accessType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { value: 0, label: "全部" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: 1, label: "首次访问" },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          value: 2,
                                          label: "时间段访问过",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          value: 3,
                                          label: "时间段未访问",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "性别：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: { placeholder: "请选择" },
                                      model: {
                                        value: _vm.userFrom.sex,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.userFrom, "sex", $$v)
                                        },
                                        expression: "userFrom.sex",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { value: "", label: "全部" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: 0, label: "未知" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: 1, label: "男" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: 2, label: "女" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: 3, label: "保密" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "身份：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: { placeholder: "请选择" },
                                      model: {
                                        value: _vm.userFrom.isPromoter,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userFrom,
                                            "isPromoter",
                                            $$v
                                          )
                                        },
                                        expression: "userFrom.isPromoter",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { value: "", label: "全部" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: 1, label: "推广员" },
                                      }),
                                      _c("el-option", {
                                        attrs: { value: 0, label: "普通用户" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "search-form-sub-bottom" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "ios-search",
                                    label: "default",
                                  },
                                  on: { click: _vm.userSearchs },
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "ResetSearch mr14",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.reset("userFrom")
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "ivu-ml-8",
                                  on: {
                                    click: function ($event) {
                                      _vm.collapse = !_vm.collapse
                                    },
                                  },
                                },
                                [
                                  !_vm.collapse
                                    ? [
                                        _vm._v(" 展开 "),
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down",
                                        }),
                                      ]
                                    : [
                                        _vm._v(" 收起 "),
                                        _c("i", {
                                          staticClass: "el-icon-arrow-up",
                                        }),
                                      ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-tabs",
                {
                  on: {
                    "tab-click": function ($event) {
                      return _vm.getList(1)
                    },
                  },
                  model: {
                    value: _vm.loginType,
                    callback: function ($$v) {
                      _vm.loginType = $$v
                    },
                    expression: "loginType",
                  },
                },
                _vm._l(_vm.headeNum, function (item, index) {
                  return _c("el-tab-pane", {
                    key: index,
                    attrs: { label: item.name, name: item.type.toString() },
                  })
                }),
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:coupon:user:receive"],
                          expression: "['admin:coupon:user:receive']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.onSend },
                    },
                    [_vm._v("发送优惠券")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:user:group"],
                          expression: "['admin:user:group']",
                        },
                      ],
                      attrs: { disabled: !_vm.selectionList.length },
                      on: {
                        click: function ($event) {
                          return _vm.setBatch("group")
                        },
                      },
                    },
                    [_vm._v("批量设置分组")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:user:tag"],
                          expression: "['admin:user:tag']",
                        },
                      ],
                      attrs: { disabled: !_vm.selectionList.length },
                      on: {
                        click: function ($event) {
                          return _vm.setBatch("label")
                        },
                      },
                    },
                    [_vm._v("批量设置标签")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.onSelectTab },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-table-expand",
                            attrs: { "label-position": "left", inline: "" },
                          },
                          [
                            _c("el-form-item", { attrs: { label: "身份：" } }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterIsPromoter")(
                                      props.row.isPromoter
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _c(
                              "el-form-item",
                              { attrs: { label: "首次访问：" } },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        props.row.createTime
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "近次访问：" } },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        props.row.lastLoginTime
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "手机号：" } },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(props.row.phone)
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c("el-form-item", { attrs: { label: "标签：" } }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterEmpty")(props.row.tagName)
                                  )
                                ),
                              ]),
                            ]),
                            _c("el-form-item", { attrs: { label: "地址：" } }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterEmpty")(props.row.addres)
                                  )
                                ),
                              ]),
                            ]),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: {
                                  width: "100%",
                                  display: "flex",
                                  "margin-right": "10px",
                                },
                                attrs: { label: "备注：" },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(props.row.mark)
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm.checkedCities.includes("ID")
                ? _c("el-table-column", {
                    attrs: { prop: "uid", label: "ID", "min-width": "80" },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("头像")
                ? _c("el-table-column", {
                    attrs: { label: "头像", "min-width": "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "demo-image__preview" },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "36px",
                                      height: "36px",
                                    },
                                    attrs: {
                                      src: scope.row.avatar,
                                      "preview-src-list": [scope.row.avatar],
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3573681484
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("姓名")
                ? _c("el-table-column", {
                    attrs: { label: "姓名", "min-width": "160" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterEmpty")(scope.row.nickname)
                                  ) +
                                    " | " +
                                    _vm._s(_vm._f("sexFilter")(scope.row.sex))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3077128138
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("用户等级")
                ? _c("el-table-column", {
                    attrs: { label: "用户等级", "min-width": "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterEmpty")(
                                      _vm._f("levelFilter")(scope.row.level)
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      88540595
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("分组")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "groupName",
                      label: "分组",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.groupName || "-")),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      690074035
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("推荐人")
                ? _c("el-table-column", {
                    attrs: { label: "推荐人", "min-width": "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.spreadNickname &&
                              scope.row.spreadNickname !== "无"
                                ? _c("div", { staticClass: "spread-cell" }, [
                                    _c(
                                      "span",
                                      { staticClass: "spread-cell-name" },
                                      [_vm._v(_vm._s(scope.row.spreadNickname))]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "spread-cell-phone" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("filterEmpty")(
                                              scope.row.spreadPhone
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ])
                                : _c("span", [_vm._v("无")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1038024721
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("手机号")
                ? _c("el-table-column", {
                    attrs: { label: "手机号", "min-width": "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("filterEmpty")(scope.row.phone))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3743808278
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("邀请码")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "inviteCode",
                      label: "邀请码",
                      "min-width": "120",
                    },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "160",
                  fixed: "right",
                  "render-header": _vm.renderHeader,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:user:topdetail"],
                                expression: "['admin:user:topdetail']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.onDetails(scope.row.uid)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:user:infobycondition"],
                                expression: "['admin:user:infobycondition']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.editUser(scope.row.uid)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _vm._v(" 更多"),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _vm.checkPermi(["admin:user:operate:founds"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.editPoint(scope.row.uid)
                                          },
                                        },
                                      },
                                      [_vm._v("积分余额")]
                                    )
                                  : _vm._e(),
                                _vm.checkPermi(["admin:user:group"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.setBatch(
                                              "group",
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("设置分组")]
                                    )
                                  : _vm._e(),
                                _vm.checkPermi(["admin:user:tag"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.setBatch(
                                              "label",
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("设置标签")]
                                    )
                                  : _vm._e(),
                                _vm.checkPermi(["admin:user:update:phone"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.setPhone(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("修改手机号")]
                                    )
                                  : _vm._e(),
                                _vm.checkPermi(["admin:user:update:level"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.onLevel(
                                              scope.row.uid,
                                              scope.row.level
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("修改用户等级")]
                                    )
                                  : _vm._e(),
                                _vm.checkPermi(["admin:user:update:spread"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.setExtension(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("修改上级推广人")]
                                    )
                                  : _vm._e(),
                                scope.row.spreadUid &&
                                scope.row.spreadUid > 0 &&
                                _vm.checkPermi(["admin:retail:spread:clean"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.clearSpread(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("清除上级推广人")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.userFrom.limit,
                  "current-page": _vm.userFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.card_select_show,
              expression: "card_select_show",
            },
          ],
          staticClass: "card_abs",
          style: { top: _vm.collapse ? 570 + "px" : 270 + "px" },
        },
        [
          [
            _c(
              "div",
              { staticClass: "cell_ht" },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { indeterminate: _vm.isIndeterminate },
                    on: { change: _vm.handleCheckAllChange },
                    model: {
                      value: _vm.checkAll,
                      callback: function ($$v) {
                        _vm.checkAll = $$v
                      },
                      expression: "checkAll",
                    },
                  },
                  [_vm._v("全选")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.checkSave()
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
            _c(
              "el-checkbox-group",
              {
                on: { change: _vm.handleCheckedCitiesChange },
                model: {
                  value: _vm.checkedCities,
                  callback: function ($$v) {
                    _vm.checkedCities = $$v
                  },
                  expression: "checkedCities",
                },
              },
              _vm._l(_vm.columnData, function (item) {
                return _c(
                  "el-checkbox",
                  {
                    key: item,
                    staticClass: "check_cell",
                    attrs: { label: item },
                  },
                  [_vm._v(_vm._s(item))]
                )
              }),
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改推广人",
            visible: _vm.extensionVisible,
            width: "680px",
            "before-close": _vm.handleCloseExtension,
          },
          on: {
            "update:visible": function ($event) {
              _vm.extensionVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formExtension",
              staticClass: "formExtension",
              attrs: {
                model: _vm.formExtension,
                rules: _vm.ruleInline,
                "label-width": "90px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "上级手机号：", prop: "spreadUid" } },
                [
                  _c("el-input", {
                    staticClass: "spread-phone-input",
                    attrs: {
                      placeholder: "请输入上级推广人手机号搜索",
                      clearable: "",
                    },
                    on: {
                      clear: function ($event) {
                        _vm.spreadUserList = []
                      },
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchSpreadUser($event)
                      },
                    },
                    model: {
                      value: _vm.spreadPhone,
                      callback: function ($$v) {
                        _vm.spreadPhone = $$v
                      },
                      expression: "spreadPhone",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.searchSpreadUser },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
              _vm.spreadUserList.length
                ? _c(
                    "el-form-item",
                    { attrs: { label: "选择上级：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "spread-user-list",
                          model: {
                            value: _vm.formExtension.spreadUid,
                            callback: function ($$v) {
                              _vm.$set(_vm.formExtension, "spreadUid", $$v)
                            },
                            expression: "formExtension.spreadUid",
                          },
                        },
                        _vm._l(_vm.spreadUserList, function (item) {
                          return _c(
                            "el-radio",
                            {
                              key: item.uid,
                              staticClass: "spread-user-item",
                              attrs: { label: item.uid, border: "" },
                            },
                            [
                              _c("div", { staticClass: "spread-user-info" }, [
                                item.avatar
                                  ? _c("img", {
                                      staticClass: "spread-avatar",
                                      attrs: { src: item.avatar },
                                    })
                                  : _vm._e(),
                                _c("span", { staticClass: "spread-name" }, [
                                  _vm._v(_vm._s(item.nickname || "未命名")),
                                ]),
                                _c("span", { staticClass: "spread-phone" }, [
                                  _vm._v(_vm._s(item.phone)),
                                ]),
                              ]),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formExtension.spreadUid
                ? _c("el-form-item", { attrs: { label: "已选上级：" } }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.selectedSpreadUser.nickname || "未命名") +
                          "（" +
                          _vm._s(_vm.selectedSpreadUser.phone) +
                          "）"
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.extensionVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onSubExtension("formExtension")
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置",
            visible: _vm.dialogVisible,
            width: "540px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "dynamicValidateForm",
              staticClass: "demo-dynamic",
              attrs: { model: _vm.dynamicValidateForm, "label-width": "75px" },
            },
            [
              _vm.batchName === "group"
                ? _c(
                    "el-form-item",
                    {
                      key: "1",
                      attrs: {
                        prop: "groupId",
                        label: "用户分组：",
                        rules: [
                          {
                            required: true,
                            message: "请选择用户分组",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择分组", filterable: "" },
                          model: {
                            value: _vm.dynamicValidateForm.groupId,
                            callback: function ($$v) {
                              _vm.$set(_vm.dynamicValidateForm, "groupId", $$v)
                            },
                            expression: "dynamicValidateForm.groupId",
                          },
                        },
                        _vm._l(_vm.groupList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item.id, label: item.groupName },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "groupId",
                        label: "用户标签：",
                        rules: [
                          {
                            required: true,
                            message: "请选择用户标签",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择标签",
                            multiple: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.dynamicValidateForm.groupId,
                            callback: function ($$v) {
                              _vm.$set(_vm.dynamicValidateForm, "groupId", $$v)
                            },
                            expression: "dynamicValidateForm.groupId",
                          },
                        },
                        _vm._l(_vm.labelLists, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item.id, label: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("dynamicValidateForm")
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "编辑", visible: _vm.visible, width: "900px" },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.visible
            ? _c("edit-from", {
                attrs: { uid: _vm.uid },
                on: { resetForm: _vm.resetForm },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "积分余额",
            visible: _vm.VisiblePoint,
            width: "540px",
            "close-on-click-modal": false,
            "before-close": _vm.handlePointClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.VisiblePoint = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingPoint,
                  expression: "loadingPoint",
                },
              ],
              ref: "PointValidateForm",
              staticClass: "demo-dynamic",
              attrs: { model: _vm.PointValidateForm, "label-width": "80px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "修改余额：", required: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.PointValidateForm.moneyType,
                        callback: function ($$v) {
                          _vm.$set(_vm.PointValidateForm, "moneyType", $$v)
                        },
                        expression: "PointValidateForm.moneyType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("增加")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("减少")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "余额：", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      "controls-position": "right",
                      type: "text",
                      precision: 2,
                      step: 0.1,
                      min: 0,
                      max: 999999,
                    },
                    model: {
                      value: _vm.PointValidateForm.moneyValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.PointValidateForm, "moneyValue", $$v)
                      },
                      expression: "PointValidateForm.moneyValue",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "修改积分：", required: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.PointValidateForm.integralType,
                        callback: function ($$v) {
                          _vm.$set(_vm.PointValidateForm, "integralType", $$v)
                        },
                        expression: "PointValidateForm.integralType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("增加")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("减少")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "积分：", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      "controls-position": "right",
                      type: "text",
                      "step-strictly": "",
                      min: 0,
                      max: 999999,
                    },
                    model: {
                      value: _vm.PointValidateForm.integralValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.PointValidateForm, "integralValue", $$v)
                      },
                      expression: "PointValidateForm.integralValue",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handlePointClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingBtn },
                  on: {
                    click: function ($event) {
                      return _vm.submitPointForm("PointValidateForm")
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("user-details", { ref: "userDetailFrom", attrs: { userNo: _vm.uid } }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置",
            visible: _vm.levelVisible,
            width: "540px",
            "before-close": _vm.Close,
          },
          on: {
            "update:visible": function ($event) {
              _vm.levelVisible = $event
            },
          },
        },
        [
          _c("level-edit", {
            attrs: { levelInfo: _vm.levelInfo, levelList: _vm.levelList },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }